import type { Row } from './inventoryValues';

import { inventoryCsvParts } from './model';

/** Encode each bounded text part immediately, avoiding a retained full-export Array<string>. */
export function inventoryCsvBlob(
  rows: ReadonlyArray<Row>,
  columns: Array<string>,
  context: Row = {},
  exportedAt = new Date().toISOString(),
): Blob {
  const parts: Array<Blob> = [];
  for (const part of inventoryCsvParts(rows, columns, context, exportedAt)) parts.push(new Blob([part]));
  return new Blob(parts, { type: 'text/csv;charset=utf-8' });
}
